import { render, staticRenderFns } from "./OrderDuplicate.vue?vue&type=template&id=cc65549c&"
import script from "./OrderDuplicate.vue?vue&type=script&lang=js&"
export * from "./OrderDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports